// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2CELF","footer":"ModalError_footer__1qKZY"};